import Swiper from 'swiper';
import $ from 'jquery';

class Carousel {

	constructor() {
		var self = this;

		this.swiper_hero = null;

		var ua = window.navigator.userAgent;
		var isIE = /MSIE|Trident/.test(ua);


		this.init();

		self.updateSlider();

		$(window).resize(function () {
			self.updateSlider();
		});

	}

	updateSlider() {
		var self = this;

		if ($('.hero-container').length) {
			var viewportWidth = $(window).width();

			$('.hero-container .swiper-wrapper .swiper-slide').each(function (e) {
				var $swiper = $(this);

				if (viewportWidth <= 560) {
					var mobileImage = $swiper.data('mobile-img');

					if (mobileImage) {
						$swiper.css("background-image", "url(" + mobileImage + ")");
					}
				} else {
					var desktopImage = $swiper.data('desktop-img');
					$swiper.css("background-image", "url(" + desktopImage + ")");
				}
			});

			self.swiper_hero.update();
		}
	}

	init() {
		// Hero
		this.swiper_hero = new Swiper('.hero-container .swiper-container', {
			slidesPerView: 1,
			autoHeight: true,
			spaceBetween: 0,
			speed: 1500,
			loop: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			}
		});

		// Video containers
		var swiper_video = new Swiper('.video-module .swiper-container', {
			slidesPerView: 'auto',
			spaceBetween: 30,
			draggable: true,
			breakpoints: {
				320: {
					spaceBetween: 10
				},
				580: {
					spaceBetween: 10
				},
				780: {
					spaceBetween: 30
				}
			},
			slidesPerGroup: 2,
			loop: false,
			loopFillGroupWithBlank: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			onSlideChangeStart: function () {
				// on the first slide
				if (swiper.activeIndex == 0) {
					$('.swiper-button-prev').hide()
					$('.swiper-button-next').show()
				}
				// most right postion
				else if (swiper.activeIndex == swiper.slides.length - 1) {
					$('.swiper-button-prev').show()
					$('.swiper-button-next').hide()
				}
				// middle positions
				else {
					$('.swiper-button-prev').show()
					$('.swiper-button-next').show()
				}
			}
		});


	}
}

export default Carousel;
